import { VideoChaptersMenu } from './video-chapters-menu'

const { videojs } = global
const MenuButton = videojs.getComponent('MenuButton')

/**
 * @class
 * @extends MenuButton
 */
// eslint-disable-next-line import/prefer-default-export
export class VideoChaptersButton extends MenuButton {
  /**
   * Button to toggle Video Chapters
   * @param {Player|Object} player
   */
  constructor (player) {
    super(player)
    this.addClass('vjs-video-chapters')
  }

  /**
   * return list of css classes that will be applied to container
   * @returns {string}
   */
  // eslint-disable-next-line class-methods-use-this
  buildCSSClass () {
    return 'vjs-chapters-button vjs-menu-button vjs-menu-button-popup vjs-button'
  }

  /**
   * create custom menu item
   * @returns {VideoChaptersMenu}
   */
  createMenu () {
    return new VideoChaptersMenu(this.player(), { menuButton: this })
  }
}

export default VideoChaptersButton
